import { ErrorBoundary } from "react-error-boundary";
import { Link } from "react-router-dom";

import { RenderWhen } from "../../../../../../components";
import RLCard from "../../../../../../components/card/RLCard";
import { COMPONENT_IDS, SECTIONS } from "../../../../consts";
import { useLocalSampleSummaryParams } from "../../../../hooks";
import { pathToRLCS, pathToSS } from "../../../../util";
import { DESCRIPTIONS } from "../../../layout-editor/consts";
import { useGetMergedRlcsReport } from "../../../rlcloudsandbox/hooks/useGetMergedRlcsReport";
import { Tooltip } from "../common";
import MitreAttack from "./MitreAttack";
import styles from "./mitre.module.scss";

const MitreErrorComp = () => (
  <div className={styles.error_msg}>Mitre Att&ck Error</div>
);
const MitreAttackCard = () => {
  const {
    hash = "",
    sourceId = "",
    relationshipId
  } = useLocalSampleSummaryParams();
  const { isSuccess: isRlcsSuccess } = useGetMergedRlcsReport(hash);
  return (
    <RLCard
      header={
        <RLCard.LinkHeader
          title={
            <Tooltip
              message={DESCRIPTIONS[COMPONENT_IDS.MITRE]}
              placement="top"
            >
              <span>MITRE ATT&CK</span>
            </Tooltip>
          }
          LinkComponent={
            <div className="flex flex-gap-3">
              <span>See results for: </span>
              <Link
                className={styles.link}
                to={pathToSS(
                  hash,
                  sourceId,
                  SECTIONS.FILE_ANALYSIS.MITRE,
                  relationshipId
                )}
                data-testid="report_summary_mitre_card_header_link_static_analysis"
              >
                Static Analysis
              </Link>
              <RenderWhen condition={isRlcsSuccess}>
                <div style={{ border: "1px solid #333", width: "1px" }}></div>
                <Link
                  className={styles.link}
                  to={pathToRLCS(
                    hash,
                    sourceId,
                    "mitre_attack",
                    relationshipId
                  )}
                  data-testid="report_summary_mitre_card_header_link_dynamic_analysis"
                >
                  Dynamic Analysis
                </Link>
              </RenderWhen>
            </div>
          }
        />
      }
      content={
        <RLCard.Content>
          <ErrorBoundary fallback={<MitreErrorComp />}>
            <MitreAttack hash={hash} />
          </ErrorBoundary>
        </RLCard.Content>
      }
      data-testid="report_summary_mitre_card"
    />
  );
};

export default MitreAttackCard;
